import { render, staticRenderFns } from "./TanK.vue?vue&type=template&id=bee0bf8a&scoped=true&"
import script from "./TanK.vue?vue&type=script&lang=js&"
export * from "./TanK.vue?vue&type=script&lang=js&"
import style0 from "./TanK.vue?vue&type=style&index=0&id=bee0bf8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee0bf8a",
  null
  
)

export default component.exports